import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=0489410a&"
import script from "./Chart2.vue?vue&type=script&lang=js&"
export * from "./Chart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports